// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v6.33.4
// source: entities.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "entities";

/** --- Core Entities --- */
export interface EntityReferences {
  flowSteps: { [key: string]: boolean };
  noCodeSteps: { [key: string]: boolean };
}

export interface EntityReferences_FlowStepsEntry {
  key: string;
  value: boolean;
}

export interface EntityReferences_NoCodeStepsEntry {
  key: string;
  value: boolean;
}

export interface Entities {
  entities: Entity[];
}

export interface Entity {
  id: string;
  name: string;
  type: string;
  description: string;
  createdBy: string;
  createdAt: Date | undefined;
  updatedBy: string;
  updatedAt: Date | undefined;
  references: EntityReferences | undefined;
  config:
    | { $case: "numeric"; value: NumberConfig }
    | { $case: "alphanumeric"; value: AlphanumericConfig }
    | { $case: "enum"; value: MultipleOptionsConfig }
    | { $case: "date"; value: DateConfig }
    | { $case: "phoneNumber"; value: PhoneNumberConfig }
    | { $case: "time"; value: TimeConfig }
    | { $case: "address"; value: AddressConfig }
    | { $case: "freeText"; value: FreeTextConfig }
    | { $case: "nameConfig"; value: NameConfig }
    | undefined;
}

export interface EntityCreate {
  id: string;
  name: string;
  type: string;
  description: string;
  references: EntityReferences | undefined;
  config:
    | { $case: "numeric"; value: NumberConfig }
    | { $case: "alphanumeric"; value: AlphanumericConfig }
    | { $case: "enum"; value: MultipleOptionsConfig }
    | { $case: "date"; value: DateConfig }
    | { $case: "phoneNumber"; value: PhoneNumberConfig }
    | { $case: "time"; value: TimeConfig }
    | { $case: "address"; value: AddressConfig }
    | { $case: "freeText"; value: FreeTextConfig }
    | { $case: "nameConfig"; value: NameConfig }
    | undefined;
}

export interface EntityUpdate {
  id: string;
  name: string;
  type: string;
  description: string;
  references: EntityReferences | undefined;
  config:
    | { $case: "numeric"; value: NumberConfig }
    | { $case: "alphanumeric"; value: AlphanumericConfig }
    | { $case: "enum"; value: MultipleOptionsConfig }
    | { $case: "date"; value: DateConfig }
    | { $case: "phoneNumber"; value: PhoneNumberConfig }
    | { $case: "time"; value: TimeConfig }
    | { $case: "address"; value: AddressConfig }
    | { $case: "freeText"; value: FreeTextConfig }
    | { $case: "nameConfig"; value: NameConfig }
    | undefined;
}

export interface EntityDelete {
  id: string;
}

export interface NumberConfig {
  hasDecimal: boolean;
  hasRange: boolean;
  min?: number | undefined;
  max?: number | undefined;
}

export interface AlphanumericConfig {
  enabled: boolean;
  validationType: string;
  regularExpression: string;
}

export interface MultipleOptionsConfig {
  options: string[];
}

export interface DateConfig {
  relativeDate: boolean;
}

export interface PhoneNumberConfig {
  enabled: boolean;
  countryCodes: string[];
}

export interface TimeConfig {
  enabled: boolean;
  startTime: string;
  endTime: string;
}

/** Entity types that don't require a specific configuration yet. */
export interface AddressConfig {
}

export interface FreeTextConfig {
}

export interface NameConfig {
}

function createBaseEntityReferences(): EntityReferences {
  return { flowSteps: {}, noCodeSteps: {} };
}

export const EntityReferences: MessageFns<EntityReferences> = {
  encode(message: EntityReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.flowSteps).forEach(([key, value]: [string, boolean]) => {
      EntityReferences_FlowStepsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.noCodeSteps).forEach(([key, value]: [string, boolean]) => {
      EntityReferences_NoCodeStepsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntityReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntityReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = EntityReferences_FlowStepsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.flowSteps[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = EntityReferences_NoCodeStepsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.noCodeSteps[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntityReferences {
    return {
      flowSteps: isObject(object.flowSteps)
        ? (globalThis.Object.entries(object.flowSteps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.flow_steps)
        ? (globalThis.Object.entries(object.flow_steps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      noCodeSteps: isObject(object.noCodeSteps)
        ? (globalThis.Object.entries(object.noCodeSteps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.no_code_steps)
        ? (globalThis.Object.entries(object.no_code_steps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: EntityReferences): unknown {
    const obj: any = {};
    if (message.flowSteps) {
      const entries = globalThis.Object.entries(message.flowSteps) as [string, boolean][];
      if (entries.length > 0) {
        obj.flowSteps = {};
        entries.forEach(([k, v]) => {
          obj.flowSteps[k] = v;
        });
      }
    }
    if (message.noCodeSteps) {
      const entries = globalThis.Object.entries(message.noCodeSteps) as [string, boolean][];
      if (entries.length > 0) {
        obj.noCodeSteps = {};
        entries.forEach(([k, v]) => {
          obj.noCodeSteps[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<EntityReferences>): EntityReferences {
    return EntityReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EntityReferences>): EntityReferences {
    const message = createBaseEntityReferences();
    message.flowSteps = (globalThis.Object.entries(object.flowSteps ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.noCodeSteps = (globalThis.Object.entries(object.noCodeSteps ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseEntityReferences_FlowStepsEntry(): EntityReferences_FlowStepsEntry {
  return { key: "", value: false };
}

export const EntityReferences_FlowStepsEntry: MessageFns<EntityReferences_FlowStepsEntry> = {
  encode(message: EntityReferences_FlowStepsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntityReferences_FlowStepsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntityReferences_FlowStepsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntityReferences_FlowStepsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: EntityReferences_FlowStepsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<EntityReferences_FlowStepsEntry>): EntityReferences_FlowStepsEntry {
    return EntityReferences_FlowStepsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EntityReferences_FlowStepsEntry>): EntityReferences_FlowStepsEntry {
    const message = createBaseEntityReferences_FlowStepsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseEntityReferences_NoCodeStepsEntry(): EntityReferences_NoCodeStepsEntry {
  return { key: "", value: false };
}

export const EntityReferences_NoCodeStepsEntry: MessageFns<EntityReferences_NoCodeStepsEntry> = {
  encode(message: EntityReferences_NoCodeStepsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntityReferences_NoCodeStepsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntityReferences_NoCodeStepsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntityReferences_NoCodeStepsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: EntityReferences_NoCodeStepsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<EntityReferences_NoCodeStepsEntry>): EntityReferences_NoCodeStepsEntry {
    return EntityReferences_NoCodeStepsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EntityReferences_NoCodeStepsEntry>): EntityReferences_NoCodeStepsEntry {
    const message = createBaseEntityReferences_NoCodeStepsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseEntities(): Entities {
  return { entities: [] };
}

export const Entities: MessageFns<Entities> = {
  encode(message: Entities, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entities) {
      Entity.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Entities {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntities();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entities.push(Entity.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Entities {
    return {
      entities: globalThis.Array.isArray(object?.entities) ? object.entities.map((e: any) => Entity.fromJSON(e)) : [],
    };
  },

  toJSON(message: Entities): unknown {
    const obj: any = {};
    if (message.entities?.length) {
      obj.entities = message.entities.map((e) => Entity.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Entities>): Entities {
    return Entities.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Entities>): Entities {
    const message = createBaseEntities();
    message.entities = object.entities?.map((e) => Entity.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEntity(): Entity {
  return {
    id: "",
    name: "",
    type: "",
    description: "",
    createdBy: "",
    createdAt: undefined,
    updatedBy: "",
    updatedAt: undefined,
    references: undefined,
    config: undefined,
  };
}

export const Entity: MessageFns<Entity> = {
  encode(message: Entity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.type !== "") {
      writer.uint32(26).string(message.type);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(58).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(66).fork()).join();
    }
    if (message.references !== undefined) {
      EntityReferences.encode(message.references, writer.uint32(74).fork()).join();
    }
    switch (message.config?.$case) {
      case "numeric":
        NumberConfig.encode(message.config.value, writer.uint32(82).fork()).join();
        break;
      case "alphanumeric":
        AlphanumericConfig.encode(message.config.value, writer.uint32(90).fork()).join();
        break;
      case "enum":
        MultipleOptionsConfig.encode(message.config.value, writer.uint32(98).fork()).join();
        break;
      case "date":
        DateConfig.encode(message.config.value, writer.uint32(106).fork()).join();
        break;
      case "phoneNumber":
        PhoneNumberConfig.encode(message.config.value, writer.uint32(114).fork()).join();
        break;
      case "time":
        TimeConfig.encode(message.config.value, writer.uint32(122).fork()).join();
        break;
      case "address":
        AddressConfig.encode(message.config.value, writer.uint32(130).fork()).join();
        break;
      case "freeText":
        FreeTextConfig.encode(message.config.value, writer.uint32(138).fork()).join();
        break;
      case "nameConfig":
        NameConfig.encode(message.config.value, writer.uint32(146).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Entity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.references = EntityReferences.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.config = { $case: "numeric", value: NumberConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.config = { $case: "alphanumeric", value: AlphanumericConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.config = { $case: "enum", value: MultipleOptionsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.config = { $case: "date", value: DateConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.config = { $case: "phoneNumber", value: PhoneNumberConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.config = { $case: "time", value: TimeConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.config = { $case: "address", value: AddressConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.config = { $case: "freeText", value: FreeTextConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.config = { $case: "nameConfig", value: NameConfig.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Entity {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      references: isSet(object.references) ? EntityReferences.fromJSON(object.references) : undefined,
      config: isSet(object.numeric)
        ? { $case: "numeric", value: NumberConfig.fromJSON(object.numeric) }
        : isSet(object.alphanumeric)
        ? { $case: "alphanumeric", value: AlphanumericConfig.fromJSON(object.alphanumeric) }
        : isSet(object.enum)
        ? { $case: "enum", value: MultipleOptionsConfig.fromJSON(object.enum) }
        : isSet(object.date)
        ? { $case: "date", value: DateConfig.fromJSON(object.date) }
        : isSet(object.phoneNumber)
        ? { $case: "phoneNumber", value: PhoneNumberConfig.fromJSON(object.phoneNumber) }
        : isSet(object.phone_number)
        ? { $case: "phoneNumber", value: PhoneNumberConfig.fromJSON(object.phone_number) }
        : isSet(object.time)
        ? { $case: "time", value: TimeConfig.fromJSON(object.time) }
        : isSet(object.address)
        ? { $case: "address", value: AddressConfig.fromJSON(object.address) }
        : isSet(object.freeText)
        ? { $case: "freeText", value: FreeTextConfig.fromJSON(object.freeText) }
        : isSet(object.free_text)
        ? { $case: "freeText", value: FreeTextConfig.fromJSON(object.free_text) }
        : isSet(object.nameConfig)
        ? { $case: "nameConfig", value: NameConfig.fromJSON(object.nameConfig) }
        : isSet(object.name_config)
        ? { $case: "nameConfig", value: NameConfig.fromJSON(object.name_config) }
        : undefined,
    };
  },

  toJSON(message: Entity): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.references !== undefined) {
      obj.references = EntityReferences.toJSON(message.references);
    }
    if (message.config?.$case === "numeric") {
      obj.numeric = NumberConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "alphanumeric") {
      obj.alphanumeric = AlphanumericConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "enum") {
      obj.enum = MultipleOptionsConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "date") {
      obj.date = DateConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "phoneNumber") {
      obj.phoneNumber = PhoneNumberConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "time") {
      obj.time = TimeConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "address") {
      obj.address = AddressConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "freeText") {
      obj.freeText = FreeTextConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "nameConfig") {
      obj.nameConfig = NameConfig.toJSON(message.config.value);
    }
    return obj;
  },

  create(base?: DeepPartial<Entity>): Entity {
    return Entity.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Entity>): Entity {
    const message = createBaseEntity();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.type = object.type ?? "";
    message.description = object.description ?? "";
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? EntityReferences.fromPartial(object.references)
      : undefined;
    switch (object.config?.$case) {
      case "numeric": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "numeric", value: NumberConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "alphanumeric": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "alphanumeric", value: AlphanumericConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "enum": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "enum", value: MultipleOptionsConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "date": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "date", value: DateConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "phoneNumber": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "phoneNumber", value: PhoneNumberConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "time": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "time", value: TimeConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "address": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "address", value: AddressConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "freeText": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "freeText", value: FreeTextConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "nameConfig": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "nameConfig", value: NameConfig.fromPartial(object.config.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseEntityCreate(): EntityCreate {
  return { id: "", name: "", type: "", description: "", references: undefined, config: undefined };
}

export const EntityCreate: MessageFns<EntityCreate> = {
  encode(message: EntityCreate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.type !== "") {
      writer.uint32(26).string(message.type);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.references !== undefined) {
      EntityReferences.encode(message.references, writer.uint32(42).fork()).join();
    }
    switch (message.config?.$case) {
      case "numeric":
        NumberConfig.encode(message.config.value, writer.uint32(50).fork()).join();
        break;
      case "alphanumeric":
        AlphanumericConfig.encode(message.config.value, writer.uint32(58).fork()).join();
        break;
      case "enum":
        MultipleOptionsConfig.encode(message.config.value, writer.uint32(66).fork()).join();
        break;
      case "date":
        DateConfig.encode(message.config.value, writer.uint32(74).fork()).join();
        break;
      case "phoneNumber":
        PhoneNumberConfig.encode(message.config.value, writer.uint32(82).fork()).join();
        break;
      case "time":
        TimeConfig.encode(message.config.value, writer.uint32(90).fork()).join();
        break;
      case "address":
        AddressConfig.encode(message.config.value, writer.uint32(98).fork()).join();
        break;
      case "freeText":
        FreeTextConfig.encode(message.config.value, writer.uint32(106).fork()).join();
        break;
      case "nameConfig":
        NameConfig.encode(message.config.value, writer.uint32(114).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntityCreate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntityCreate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.references = EntityReferences.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = { $case: "numeric", value: NumberConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.config = { $case: "alphanumeric", value: AlphanumericConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.config = { $case: "enum", value: MultipleOptionsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.config = { $case: "date", value: DateConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.config = { $case: "phoneNumber", value: PhoneNumberConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.config = { $case: "time", value: TimeConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.config = { $case: "address", value: AddressConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.config = { $case: "freeText", value: FreeTextConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.config = { $case: "nameConfig", value: NameConfig.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntityCreate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      references: isSet(object.references) ? EntityReferences.fromJSON(object.references) : undefined,
      config: isSet(object.numeric)
        ? { $case: "numeric", value: NumberConfig.fromJSON(object.numeric) }
        : isSet(object.alphanumeric)
        ? { $case: "alphanumeric", value: AlphanumericConfig.fromJSON(object.alphanumeric) }
        : isSet(object.enum)
        ? { $case: "enum", value: MultipleOptionsConfig.fromJSON(object.enum) }
        : isSet(object.date)
        ? { $case: "date", value: DateConfig.fromJSON(object.date) }
        : isSet(object.phoneNumber)
        ? { $case: "phoneNumber", value: PhoneNumberConfig.fromJSON(object.phoneNumber) }
        : isSet(object.phone_number)
        ? { $case: "phoneNumber", value: PhoneNumberConfig.fromJSON(object.phone_number) }
        : isSet(object.time)
        ? { $case: "time", value: TimeConfig.fromJSON(object.time) }
        : isSet(object.address)
        ? { $case: "address", value: AddressConfig.fromJSON(object.address) }
        : isSet(object.freeText)
        ? { $case: "freeText", value: FreeTextConfig.fromJSON(object.freeText) }
        : isSet(object.free_text)
        ? { $case: "freeText", value: FreeTextConfig.fromJSON(object.free_text) }
        : isSet(object.nameConfig)
        ? { $case: "nameConfig", value: NameConfig.fromJSON(object.nameConfig) }
        : isSet(object.name_config)
        ? { $case: "nameConfig", value: NameConfig.fromJSON(object.name_config) }
        : undefined,
    };
  },

  toJSON(message: EntityCreate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.references !== undefined) {
      obj.references = EntityReferences.toJSON(message.references);
    }
    if (message.config?.$case === "numeric") {
      obj.numeric = NumberConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "alphanumeric") {
      obj.alphanumeric = AlphanumericConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "enum") {
      obj.enum = MultipleOptionsConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "date") {
      obj.date = DateConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "phoneNumber") {
      obj.phoneNumber = PhoneNumberConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "time") {
      obj.time = TimeConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "address") {
      obj.address = AddressConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "freeText") {
      obj.freeText = FreeTextConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "nameConfig") {
      obj.nameConfig = NameConfig.toJSON(message.config.value);
    }
    return obj;
  },

  create(base?: DeepPartial<EntityCreate>): EntityCreate {
    return EntityCreate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EntityCreate>): EntityCreate {
    const message = createBaseEntityCreate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.type = object.type ?? "";
    message.description = object.description ?? "";
    message.references = (object.references !== undefined && object.references !== null)
      ? EntityReferences.fromPartial(object.references)
      : undefined;
    switch (object.config?.$case) {
      case "numeric": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "numeric", value: NumberConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "alphanumeric": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "alphanumeric", value: AlphanumericConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "enum": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "enum", value: MultipleOptionsConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "date": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "date", value: DateConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "phoneNumber": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "phoneNumber", value: PhoneNumberConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "time": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "time", value: TimeConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "address": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "address", value: AddressConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "freeText": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "freeText", value: FreeTextConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "nameConfig": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "nameConfig", value: NameConfig.fromPartial(object.config.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseEntityUpdate(): EntityUpdate {
  return { id: "", name: "", type: "", description: "", references: undefined, config: undefined };
}

export const EntityUpdate: MessageFns<EntityUpdate> = {
  encode(message: EntityUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.type !== "") {
      writer.uint32(26).string(message.type);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.references !== undefined) {
      EntityReferences.encode(message.references, writer.uint32(42).fork()).join();
    }
    switch (message.config?.$case) {
      case "numeric":
        NumberConfig.encode(message.config.value, writer.uint32(50).fork()).join();
        break;
      case "alphanumeric":
        AlphanumericConfig.encode(message.config.value, writer.uint32(58).fork()).join();
        break;
      case "enum":
        MultipleOptionsConfig.encode(message.config.value, writer.uint32(66).fork()).join();
        break;
      case "date":
        DateConfig.encode(message.config.value, writer.uint32(74).fork()).join();
        break;
      case "phoneNumber":
        PhoneNumberConfig.encode(message.config.value, writer.uint32(82).fork()).join();
        break;
      case "time":
        TimeConfig.encode(message.config.value, writer.uint32(90).fork()).join();
        break;
      case "address":
        AddressConfig.encode(message.config.value, writer.uint32(98).fork()).join();
        break;
      case "freeText":
        FreeTextConfig.encode(message.config.value, writer.uint32(106).fork()).join();
        break;
      case "nameConfig":
        NameConfig.encode(message.config.value, writer.uint32(114).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntityUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntityUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.references = EntityReferences.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = { $case: "numeric", value: NumberConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.config = { $case: "alphanumeric", value: AlphanumericConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.config = { $case: "enum", value: MultipleOptionsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.config = { $case: "date", value: DateConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.config = { $case: "phoneNumber", value: PhoneNumberConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.config = { $case: "time", value: TimeConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.config = { $case: "address", value: AddressConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.config = { $case: "freeText", value: FreeTextConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.config = { $case: "nameConfig", value: NameConfig.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntityUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      references: isSet(object.references) ? EntityReferences.fromJSON(object.references) : undefined,
      config: isSet(object.numeric)
        ? { $case: "numeric", value: NumberConfig.fromJSON(object.numeric) }
        : isSet(object.alphanumeric)
        ? { $case: "alphanumeric", value: AlphanumericConfig.fromJSON(object.alphanumeric) }
        : isSet(object.enum)
        ? { $case: "enum", value: MultipleOptionsConfig.fromJSON(object.enum) }
        : isSet(object.date)
        ? { $case: "date", value: DateConfig.fromJSON(object.date) }
        : isSet(object.phoneNumber)
        ? { $case: "phoneNumber", value: PhoneNumberConfig.fromJSON(object.phoneNumber) }
        : isSet(object.phone_number)
        ? { $case: "phoneNumber", value: PhoneNumberConfig.fromJSON(object.phone_number) }
        : isSet(object.time)
        ? { $case: "time", value: TimeConfig.fromJSON(object.time) }
        : isSet(object.address)
        ? { $case: "address", value: AddressConfig.fromJSON(object.address) }
        : isSet(object.freeText)
        ? { $case: "freeText", value: FreeTextConfig.fromJSON(object.freeText) }
        : isSet(object.free_text)
        ? { $case: "freeText", value: FreeTextConfig.fromJSON(object.free_text) }
        : isSet(object.nameConfig)
        ? { $case: "nameConfig", value: NameConfig.fromJSON(object.nameConfig) }
        : isSet(object.name_config)
        ? { $case: "nameConfig", value: NameConfig.fromJSON(object.name_config) }
        : undefined,
    };
  },

  toJSON(message: EntityUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.references !== undefined) {
      obj.references = EntityReferences.toJSON(message.references);
    }
    if (message.config?.$case === "numeric") {
      obj.numeric = NumberConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "alphanumeric") {
      obj.alphanumeric = AlphanumericConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "enum") {
      obj.enum = MultipleOptionsConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "date") {
      obj.date = DateConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "phoneNumber") {
      obj.phoneNumber = PhoneNumberConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "time") {
      obj.time = TimeConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "address") {
      obj.address = AddressConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "freeText") {
      obj.freeText = FreeTextConfig.toJSON(message.config.value);
    } else if (message.config?.$case === "nameConfig") {
      obj.nameConfig = NameConfig.toJSON(message.config.value);
    }
    return obj;
  },

  create(base?: DeepPartial<EntityUpdate>): EntityUpdate {
    return EntityUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EntityUpdate>): EntityUpdate {
    const message = createBaseEntityUpdate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.type = object.type ?? "";
    message.description = object.description ?? "";
    message.references = (object.references !== undefined && object.references !== null)
      ? EntityReferences.fromPartial(object.references)
      : undefined;
    switch (object.config?.$case) {
      case "numeric": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "numeric", value: NumberConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "alphanumeric": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "alphanumeric", value: AlphanumericConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "enum": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "enum", value: MultipleOptionsConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "date": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "date", value: DateConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "phoneNumber": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "phoneNumber", value: PhoneNumberConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "time": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "time", value: TimeConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "address": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "address", value: AddressConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "freeText": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "freeText", value: FreeTextConfig.fromPartial(object.config.value) };
        }
        break;
      }
      case "nameConfig": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "nameConfig", value: NameConfig.fromPartial(object.config.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseEntityDelete(): EntityDelete {
  return { id: "" };
}

export const EntityDelete: MessageFns<EntityDelete> = {
  encode(message: EntityDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntityDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntityDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntityDelete {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: EntityDelete): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<EntityDelete>): EntityDelete {
    return EntityDelete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EntityDelete>): EntityDelete {
    const message = createBaseEntityDelete();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseNumberConfig(): NumberConfig {
  return { hasDecimal: false, hasRange: false, min: undefined, max: undefined };
}

export const NumberConfig: MessageFns<NumberConfig> = {
  encode(message: NumberConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hasDecimal !== false) {
      writer.uint32(8).bool(message.hasDecimal);
    }
    if (message.hasRange !== false) {
      writer.uint32(16).bool(message.hasRange);
    }
    if (message.min !== undefined) {
      writer.uint32(29).float(message.min);
    }
    if (message.max !== undefined) {
      writer.uint32(37).float(message.max);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NumberConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNumberConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hasDecimal = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hasRange = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.min = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.max = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NumberConfig {
    return {
      hasDecimal: isSet(object.hasDecimal)
        ? globalThis.Boolean(object.hasDecimal)
        : isSet(object.has_decimal)
        ? globalThis.Boolean(object.has_decimal)
        : false,
      hasRange: isSet(object.hasRange)
        ? globalThis.Boolean(object.hasRange)
        : isSet(object.has_range)
        ? globalThis.Boolean(object.has_range)
        : false,
      min: isSet(object.min) ? globalThis.Number(object.min) : undefined,
      max: isSet(object.max) ? globalThis.Number(object.max) : undefined,
    };
  },

  toJSON(message: NumberConfig): unknown {
    const obj: any = {};
    if (message.hasDecimal !== false) {
      obj.hasDecimal = message.hasDecimal;
    }
    if (message.hasRange !== false) {
      obj.hasRange = message.hasRange;
    }
    if (message.min !== undefined) {
      obj.min = message.min;
    }
    if (message.max !== undefined) {
      obj.max = message.max;
    }
    return obj;
  },

  create(base?: DeepPartial<NumberConfig>): NumberConfig {
    return NumberConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NumberConfig>): NumberConfig {
    const message = createBaseNumberConfig();
    message.hasDecimal = object.hasDecimal ?? false;
    message.hasRange = object.hasRange ?? false;
    message.min = object.min ?? undefined;
    message.max = object.max ?? undefined;
    return message;
  },
};

function createBaseAlphanumericConfig(): AlphanumericConfig {
  return { enabled: false, validationType: "", regularExpression: "" };
}

export const AlphanumericConfig: MessageFns<AlphanumericConfig> = {
  encode(message: AlphanumericConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.validationType !== "") {
      writer.uint32(18).string(message.validationType);
    }
    if (message.regularExpression !== "") {
      writer.uint32(26).string(message.regularExpression);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlphanumericConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAlphanumericConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.validationType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.regularExpression = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AlphanumericConfig {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      validationType: isSet(object.validationType)
        ? globalThis.String(object.validationType)
        : isSet(object.validation_type)
        ? globalThis.String(object.validation_type)
        : "",
      regularExpression: isSet(object.regularExpression)
        ? globalThis.String(object.regularExpression)
        : isSet(object.regular_expression)
        ? globalThis.String(object.regular_expression)
        : "",
    };
  },

  toJSON(message: AlphanumericConfig): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.validationType !== "") {
      obj.validationType = message.validationType;
    }
    if (message.regularExpression !== "") {
      obj.regularExpression = message.regularExpression;
    }
    return obj;
  },

  create(base?: DeepPartial<AlphanumericConfig>): AlphanumericConfig {
    return AlphanumericConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AlphanumericConfig>): AlphanumericConfig {
    const message = createBaseAlphanumericConfig();
    message.enabled = object.enabled ?? false;
    message.validationType = object.validationType ?? "";
    message.regularExpression = object.regularExpression ?? "";
    return message;
  },
};

function createBaseMultipleOptionsConfig(): MultipleOptionsConfig {
  return { options: [] };
}

export const MultipleOptionsConfig: MessageFns<MultipleOptionsConfig> = {
  encode(message: MultipleOptionsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.options) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultipleOptionsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultipleOptionsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.options.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultipleOptionsConfig {
    return {
      options: globalThis.Array.isArray(object?.options) ? object.options.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: MultipleOptionsConfig): unknown {
    const obj: any = {};
    if (message.options?.length) {
      obj.options = message.options;
    }
    return obj;
  },

  create(base?: DeepPartial<MultipleOptionsConfig>): MultipleOptionsConfig {
    return MultipleOptionsConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MultipleOptionsConfig>): MultipleOptionsConfig {
    const message = createBaseMultipleOptionsConfig();
    message.options = object.options?.map((e) => e) || [];
    return message;
  },
};

function createBaseDateConfig(): DateConfig {
  return { relativeDate: false };
}

export const DateConfig: MessageFns<DateConfig> = {
  encode(message: DateConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.relativeDate !== false) {
      writer.uint32(8).bool(message.relativeDate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DateConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDateConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.relativeDate = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DateConfig {
    return {
      relativeDate: isSet(object.relativeDate)
        ? globalThis.Boolean(object.relativeDate)
        : isSet(object.relative_date)
        ? globalThis.Boolean(object.relative_date)
        : false,
    };
  },

  toJSON(message: DateConfig): unknown {
    const obj: any = {};
    if (message.relativeDate !== false) {
      obj.relativeDate = message.relativeDate;
    }
    return obj;
  },

  create(base?: DeepPartial<DateConfig>): DateConfig {
    return DateConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DateConfig>): DateConfig {
    const message = createBaseDateConfig();
    message.relativeDate = object.relativeDate ?? false;
    return message;
  },
};

function createBasePhoneNumberConfig(): PhoneNumberConfig {
  return { enabled: false, countryCodes: [] };
}

export const PhoneNumberConfig: MessageFns<PhoneNumberConfig> = {
  encode(message: PhoneNumberConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    for (const v of message.countryCodes) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PhoneNumberConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePhoneNumberConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.countryCodes.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PhoneNumberConfig {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      countryCodes: globalThis.Array.isArray(object?.countryCodes)
        ? object.countryCodes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.country_codes)
        ? object.country_codes.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: PhoneNumberConfig): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.countryCodes?.length) {
      obj.countryCodes = message.countryCodes;
    }
    return obj;
  },

  create(base?: DeepPartial<PhoneNumberConfig>): PhoneNumberConfig {
    return PhoneNumberConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PhoneNumberConfig>): PhoneNumberConfig {
    const message = createBasePhoneNumberConfig();
    message.enabled = object.enabled ?? false;
    message.countryCodes = object.countryCodes?.map((e) => e) || [];
    return message;
  },
};

function createBaseTimeConfig(): TimeConfig {
  return { enabled: false, startTime: "", endTime: "" };
}

export const TimeConfig: MessageFns<TimeConfig> = {
  encode(message: TimeConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.startTime !== "") {
      writer.uint32(18).string(message.startTime);
    }
    if (message.endTime !== "") {
      writer.uint32(26).string(message.endTime);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TimeConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.startTime = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.endTime = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimeConfig {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      startTime: isSet(object.startTime)
        ? globalThis.String(object.startTime)
        : isSet(object.start_time)
        ? globalThis.String(object.start_time)
        : "",
      endTime: isSet(object.endTime)
        ? globalThis.String(object.endTime)
        : isSet(object.end_time)
        ? globalThis.String(object.end_time)
        : "",
    };
  },

  toJSON(message: TimeConfig): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.startTime !== "") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "") {
      obj.endTime = message.endTime;
    }
    return obj;
  },

  create(base?: DeepPartial<TimeConfig>): TimeConfig {
    return TimeConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TimeConfig>): TimeConfig {
    const message = createBaseTimeConfig();
    message.enabled = object.enabled ?? false;
    message.startTime = object.startTime ?? "";
    message.endTime = object.endTime ?? "";
    return message;
  },
};

function createBaseAddressConfig(): AddressConfig {
  return {};
}

export const AddressConfig: MessageFns<AddressConfig> = {
  encode(_: AddressConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddressConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddressConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AddressConfig {
    return {};
  },

  toJSON(_: AddressConfig): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<AddressConfig>): AddressConfig {
    return AddressConfig.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<AddressConfig>): AddressConfig {
    const message = createBaseAddressConfig();
    return message;
  },
};

function createBaseFreeTextConfig(): FreeTextConfig {
  return {};
}

export const FreeTextConfig: MessageFns<FreeTextConfig> = {
  encode(_: FreeTextConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FreeTextConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFreeTextConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): FreeTextConfig {
    return {};
  },

  toJSON(_: FreeTextConfig): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<FreeTextConfig>): FreeTextConfig {
    return FreeTextConfig.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<FreeTextConfig>): FreeTextConfig {
    const message = createBaseFreeTextConfig();
    return message;
  },
};

function createBaseNameConfig(): NameConfig {
  return {};
}

export const NameConfig: MessageFns<NameConfig> = {
  encode(_: NameConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NameConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNameConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): NameConfig {
    return {};
  },

  toJSON(_: NameConfig): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<NameConfig>): NameConfig {
    return NameConfig.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<NameConfig>): NameConfig {
    const message = createBaseNameConfig();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
